<template>
	<div class="selectFacilityComponent">
		<el-tooltip class="item" effect="light" :content="userName" placement="top" :style="{width: myWidth}">
			<el-autocomplete
      			class="inline-input"
      			v-model="userName"
      			:readonly="inputDis"
      			:fetch-suggestions="querySearch"
      			placeholder="选择设备"
      			:trigger-on-focus="false"
      			@select="handleSelect">
      			<el-button slot="append" icon="el-icon-close" @click="reset"></el-button>
				<el-button slot="append" icon="el-icon-plus" :disabled="addBtn" @click="alertDialog"></el-button>
      		</el-autocomplete>
		</el-tooltip>
		<el-dialog title="选择设备" :visible.sync="dialogVisible" width="500px" append-to-body :before-close="handleClose" :show-close="false">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText">
			</el-input>
			<div style="height:400px;" v-loading="loading">
				<el-scrollbar style="height: 100%;">
					<el-tree 
						class="filter-tree" 
						:data="data" 
						show-checkbox 
						node-key="Id" 
						:render-after-expand=false 
						:filter-node-method="filterNode" 
						@check-change="change" 
						ref="tree" 
						:check-strictly="isStrictly">
					</el-tree>
				</el-scrollbar>
			</div>
			<div style="text-align: center;">
				<el-button @click="toClose">关闭</el-button>
				<el-button type="primary" @click="toSure">确定</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import { GetDeviceProgObjectInfoByWay,listToTree } from '@/api/modules/basicData/location'
	export default {
		data(){
			return {
				filterText: '',
				data:[],
				loading: false,
				defaultProps: {
          			children: 'children',
          			label: 'label'
        		},
        		timeOut:'',
        		dialogVisible: false,
        		userName:'',
        		inputDis:false,
        		addBtn:false,
        		selectedUser:[],
        		isStrictly:false,
        		selectedData:[],
        		arr:[],
        		editCheckId: '',
        		myWidth: '',
			}
		},
		watch: {
      		filterText(val) {
        		this.$refs.tree.filter(val);
      		},
      		userName(val, oldVal) {
				if(val == ''){
					this.inputDis = false
				}
			},
    	},
    	mounted(){
    		GetDeviceProgObjectInfoByWay("12340000485005650M").then(res => {
//  			console.log(res,"选择设备")
    			for (var i = 0; i < res.length; i++) {
                    res[i].label = res[i].Name;
                }
    			this.data = listToTree('Id', 'Pid', res);
//  			this.loading = false
			})
    	},
    	props: {
			isRadio: Boolean,
			setWidth: {
				type: String,
				default: ''
			},
			isValidateMethod: {
				type: Boolean,
				default: false
			},
			
		},
		created() {
			this.myWidth=this.setWidth;
			this.checkSource()
			
		},
    	methods:{
			checkSource() {//判断父子是否关联
				if(this.isRadio == true) {
					this.isStrictly = true
				}
			},
    		querySearch(queryString, cb) {//提示搜索
    			var result = [];
    			
        		cb(result)
      		},
      		handleSelect(item) {//提示搜索下的选择
        		console.log(item,"item");
        		this.inputDis = true;
        		this.arr.push(item)
     		},
     		reset(){//叉叉
				this.inputDis = false;
				this.userName = '';
				this.selectedData = [];
				this.selectedUser = [];
				this.arr = [];
//				this.$refs.tree.setCheckedKeys([]);
			},
			alertDialog(){//点击弹出
				this.dialogVisible = true;
			},
			handleClose(done){//弹出框消失前执行
				this.dialogVisible = false;
				var beforArr = [];
				for(var i=0;i<this.selectedUser.length;i++){
					beforArr.push(this.selectedUser[i].Id)
				}
				this.$refs.tree.setCheckedKeys(beforArr);
			},
			toClose(){//取消
				this.dialogVisible = false
			},
			toSure(){//确定
				this.userName = '';
				this.arr = [];
				this.dialogVisible = false;
				this.selectedData = this.$refs.tree.getCheckedNodes();
				console.log(this.selectedData,"selectedData");
				if(this.selectedData.length>0){
					for(var i=0;i<this.selectedData.length;i++){
						if(!this.selectedData[i].children){
							this.arr.push(this.selectedData[i])
						}
					}
					this.selectedUser = this.uniqueArray(this.arr,"IP")
					console.log(this.selectedUser,"selectedUser")
					let isValidate = true;//判断验证是否通过
					if(this.isValidateMethod){//判断是否需要验证
						this.$emit("toValidate",this.selectedUser,function(str){
							isValidate = str;
						})
						if(isValidate) {
							this.assignmentInput()
						}
					} else {
						this.$emit("getValue",this.selectedUser)
						this.assignmentInput()
					}
				}
				
				console.log(this.selectedUser)
			},
			assignmentInput() { //input框赋值
				this.selectedUser.forEach((c) => {
					this.userName += c.Name + '-'
				})
				this.userName = this.userName.substring(0, this.userName.lastIndexOf('-'));
				if(this.userName != '') {
					this.inputDis = true
				}
			},
      		filterNode(value, data) {
        		if (!value) return true;
        		return data.Name.indexOf(value) !== -1;
      		},
      		change(item, node, self){
      			if(this.isRadio == true) {
					if(node == true) { //点击未选中复选框
						if(!item.children) {
							this.editCheckId = item.Id;
							this.$refs.tree.setCheckedKeys([item.Id]);
						} else {
							if(this.editCheckId != '') {
								this.$refs.tree.setCheckedKeys([this.editCheckId]);
							} else {
								this.$refs.tree.setCheckedKeys([]);
							}
						}
					}
				}
      },
      	uniqueArray(array, key){
			var result = [array[0]];
			for(var i = 1; i < array.length; i++){
			    var item = array[i];
			    var repeat = false;
			    for (var j = 0; j < result.length; j++) {
			      	if (item[key] == result[j][key]) {
			        	repeat = true;
			        	break;
			      	}
			    }
			    if (!repeat) {
			      	result.push(item);
			    }
			}
			return result;
		},
			
		}
	}
</script>